import { render, staticRenderFns } from "./GFSettlementAwaitingApproval.vue?vue&type=template&id=1d35e562"
import script from "./GFSettlementAwaitingApproval.vue?vue&type=script&lang=js"
export * from "./GFSettlementAwaitingApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports